var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnLoadRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1C9.5 1.5625 9.03125 2 8.5 2C7.9375 2 7.5 1.5625 7.5 1C7.5 0.46875 7.9375 0 8.5 0C9.03125 0 9.5 0.46875 9.5 1ZM9.5 15C9.5 15.5625 9.03125 16 8.5 16C7.9375 16 7.5 15.5625 7.5 15C7.5 14.4688 7.9375 14 8.5 14C9.03125 14 9.5 14.4688 9.5 15ZM15.5 7C16.0312 7 16.5 7.46875 16.5 8C16.5 8.5625 16.0312 9 15.5 9C14.9375 9 14.5 8.5625 14.5 8C14.5 7.46875 14.9375 7 15.5 7ZM1.5 9C0.9375 9 0.5 8.5625 0.5 8C0.5 7.46875 0.9375 7 1.5 7C2.03125 7 2.5 7.46875 2.5 8C2.5 8.5625 2.03125 9 1.5 9ZM2.8125 12.25C3.21875 11.875 3.84375 11.875 4.25 12.25C4.625 12.6562 4.625 13.2812 4.25 13.6562C3.84375 14.0625 3.21875 14.0625 2.8125 13.6562C2.4375 13.2812 2.4375 12.6562 2.8125 12.25ZM12.7188 13.6562C12.3438 13.2812 12.3438 12.6562 12.7188 12.25C13.125 11.875 13.75 11.875 14.1562 12.25C14.5312 12.6562 14.5312 13.2812 14.1562 13.6562C13.75 14.0625 13.125 14.0625 12.7188 13.6562ZM4.25 2.34375C4.625 2.75 4.625 3.375 4.25 3.78125C3.84375 4.15625 3.21875 4.15625 2.8125 3.78125C2.4375 3.375 2.4375 2.75 2.8125 2.34375C3.21875 1.96875 3.84375 1.96875 4.25 2.34375Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLoadRequest);
export default __webpack_public_path__ + "static/media/btnLoadRequest.f33de1303bc2fc98e4df2e77979ca4ba.svg";
export { ForwardRef as ReactComponent };